import { getUserFromLocalStorage } from '@/utils/user';
import { listCompaniesReduced } from '../domain/enterprise/Companies/Companies.service';
import { getGeo } from '@/utils/getGeo';
import {
  GUIDE_TEF,
  GUIDE_WELCOME_ADMIN,
  GUIDE_WELCOME_NOT_ADMIN,
  GUIDE_WORKORDER_AUTHORIZE,
  GUIDE_WORKORDER_CLOSE,
} from './guides_ids';

export default class UserGuiding {
  static async identifyUser(ug_hash?: string) {
    try {
      const user = getUserFromLocalStorage();

      if (!user.userId) return;

      let mainCompany;

      try {
        const companies = await listCompaniesReduced({ main: true });
        mainCompany = companies.data[0];
      } catch {
        mainCompany = null;
      }

      const geo = await getGeo();

      let userId = user.userId;

      if (process.env.REACT_APP_IS_HML) {
        userId = `HML_${user.userId}`;
      }

      window.userGuiding?.identify(userId, {
        email: user.userEmail as string,
        name: user.userName as string,
        module: user.module as string,
        employeId: user.employeeId as string,
        matrixId: user.matrixId as string,
        user_hash: ug_hash || user.ugHash || undefined,

        ip: geo?.ip,
        city: geo?.city,
        country_code: geo?.country_code,
        country_name: geo?.country_name,
        region: geo?.region,

        company: mainCompany
          ? {
              id: user.matrixId as string,
              name: mainCompany.name,
            }
          : undefined,
      });
    } catch {}
  }

  static goToNextGuide = window.userGuiding?.goToNextGuideStep;

  static previewGuide = window.userGuiding?.previewGuide;

  static showTEFGuide() {
    window.userGuiding?.previewGuide(GUIDE_TEF, {
      checkHistory: true,
      initialStep: 0,
    });
  }

  static showWorkOrderAuthorizeGuide() {
    window.userGuiding?.previewGuide(GUIDE_WORKORDER_AUTHORIZE, {
      checkHistory: true,
      initialStep: 0,
    });
  }

  static showWorkOrderCloseGuide() {
    window.userGuiding?.previewGuide(GUIDE_WORKORDER_CLOSE, {
      checkHistory: true,
      initialStep: 0,
    });
  }

  static showWelcomeGuid(isAdmin: boolean) {
    window.userGuiding?.previewGuide(
      isAdmin ? GUIDE_WELCOME_ADMIN : GUIDE_WELCOME_NOT_ADMIN,
      {
        checkHistory: true,
        initialStep: 0,
      },
    );
  }
}
